import { render, staticRenderFns } from "./CalendarTravel.vue?vue&type=template&id=595716cb"
import script from "./CalendarTravel.vue?vue&type=script&lang=js"
export * from "./CalendarTravel.vue?vue&type=script&lang=js"
import style0 from "./CalendarTravel.vue?vue&type=style&index=0&id=595716cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports